import React, { useEffect, useState } from 'react'
import { GetCmsPages, getAwardsAndAccolades } from '../api.services.js/others'
import { Container } from 'react-bootstrap';
import Head from 'next/head';


export const getServerSideProps=async ()=>{
  const {data}=await GetCmsPages({identifier:"about-us-awards-accolades"});
  return {
    props:{data}
  }
}
 function AboutUsAwardsAccolades(props) {
  const [cmsPage,setcmsPage]=useState(props?.data?.cmsPage?.content);
  const[awardsData, setAwardsData]=useState([])
  const[selectedYear,setSelectedYear]=useState('')
  const [activeCls, setActiveCls] = useState('')
  
  useEffect(()=>{
      getAwardsData()
  },[])
  const getAwardsData= async()=>{

    const response=await getAwardsAndAccolades();
   
    setAwardsData(response.data.awards_accolades.year_awards);
  }
 
  const breadCrumbSchema = () => {
    return {
      __html: `{
        "@context": "https://schema.org/", 
        "@type": "BreadcrumbList", 
        "itemListElement": [{
          "@type": "ListItem", 
          "position": 1, 
          "name": "Home",
          "item": "https://www.orientbell.com"
        },{
        "@type": "ListItem", 
        "position": 2, 
        "name": "About Us Awards Accolades",
        "item": "https://obl-new.orientbell.com/about-us-awards-accolades"
      }]
      }`
    }
  } 
 
 
  return (
  
    <>
    <Head>
    <title>{props?.data?.cmsPage.meta_title}</title>
    <meta name="title" content={props?.data?.cmsPage?.meta_title}/>
    <meta name="description" content={props?.data?.cmsPage?.meta_description}/>
    <meta name="keywords" content={props?.data?.cmsPage?.meta_keywords}/>
    <script type="application/ld+json" dangerouslySetInnerHTML={ breadCrumbSchema()}/>

    </Head>
    <div className='board_directors_page about_awards_accolades_page'>
    <Container>
    <div dangerouslySetInnerHTML={{__html:cmsPage}}></div>
<div className='obl-awards_accolades_years'>
{
  awardsData && awardsData.length>0 && awardsData.map((obj,index)=>{

    return (
      <div className={activeCls===(index+1)?'about_awards_accolades_years activeCls':'about_awards_accolades_years'} onClick={()=>{setSelectedYear(obj.year)
        setActiveCls(index+1)

      }}>{obj.year}</div>
    )
  })
}
</div>
    
  <div className='about_awards_accolades_con'>
    {awardsData && awardsData.length>0 && awardsData.map((obj)=>{
      // console.log("8888", obj)
         return(
          <>
          {/* <div className='about_awards_accolades_years' onClick={()=>setSelectedYear(obj.year)}>{obj.year}</div> */}
          {obj.year== selectedYear && obj.awards && obj.awards.length>0 && obj.awards.map((i)=>{
            return(
             <>
             <div className='about_awards_accolades_data'>
                <img src={i.image} alt={i.imagealt} width={200} height={200}/>
                <h4><span>{i.title}</span></h4>
                <h6>{i.content}</h6>
                </div>
                </>
            )
    })}
         
          </>
         )
    })}
    </div>

    </Container>
    </div>
    </>
    
  )
}

export default AboutUsAwardsAccolades